export default __webpack_public_path__ + "static/media/user-menu-contents.bd504ccb.png";